<script>
    import { link } from "svelte-spa-router";
    export let to;
    export let hideBackLink;
    export let title;
    export let buttons;
</script>
<div class="simple-back-nav">
    <div class="sbn-logo">
        <img src="/favicon.png" alt="Donorflow" width="32">
    </div>
    {#if !hideBackLink}
    <div class="sbn-link">
        <a href={to} use:link>&larr; Back</a>
    </div>
    {/if}
    {#if title}
    <div class="sbn-title">
        {title}
    </div>
    {/if}
    {#if buttons}
        {#each buttons as b}
            <button on:click={b.action} class={b.class}>{b.label}</button>
        {/each}
    {/if}
</div>
<style>
    .sbn-title {
        flex: 1;
        font-weight: bold;
        margin-left: 50px;
        font-size: 1.2rem;
    }
    .simple-back-nav {
        border-bottom: 1px solid #DDDDDD;
        display: flex;
        padding: 15px;
        align-items: center;
    }
    .sbn-link {
        margin-left: 20px;
    }
    .sbn-link a {
        color: #242424;
    }
    .sbn-link a:hover {
        color: #242424;
        text-decoration: none;
    }
    .sbn-link a:visited {
        color: #242424;
        text-decoration: none;
    }

</style>